<template>
  <div class="search-component">
    <div class="search-bar" :class="{focus: focused, loading: loading}">
      <input ref="search" name="search" :placeholder="$t('faq.search.placeholder')" @focus="handleFocus" @blur="handleBlur"
             @keydown="handleKeydown" v-model="search"/>
      <search-svg @click="runSearch"/>
    </div>
    <div class="search-results" v-if="requested && !loading">
      <div class="search-result-header">
        <span v-if="hasSearchResult">
          <div v-if="resultCount === 0" v-html="$t('faq.search.no_result')"></div>
          <div v-else-if="resultCount < 2" v-html="$t('faq.search.result_singular', `<span>${resultCount}</span>`, `<span>${searchTerm}</span>`)"></div>
          <div v-else v-html="$t('faq.search.result_plural', `<span>${resultCount}</span>`, `<span>${searchTerm}</span>`)"></div>
        </span>
        <span v-else>{{$t('faq.search.no_result')}}</span>
      </div>
      <div class="search-body">
        <div class="search-title" v-if="display_groups && articles.length > 0">{{$t('faq.search.articles')}}</div>
        <faq-article v-for="(item, index) in articles" :article="item" :key="item.id" :index="index"/>
        <div class="search-title" v-if="display_groups && keywords.length > 0">{{$t('faq.search.keywords')}}</div>
        <faq-keyword v-for="(item, index) in keywords" :keyword="item" :key="item.id" :index="index"/>
      </div>
    </div>
  </div>
</template>

<script>
import SearchSvg from "../../components/svg/search";
import {mapState} from "vuex";
import FaqArticle from "./article";
import FaqKeyword from "./faq-keyword";

export default {
  name: "faq-search",
  components: {FaqKeyword, FaqArticle, SearchSvg},
  data() {
    return {
      display_groups: false,
      focused: false,
      search: '',
      timer: null,
      requested: false
    }
  },
  computed: {
    ...mapState({
      loading: s => s.faq.loadingSearch
    }),
    hasSearchResult() {
      return this.$store.getters["faq/hasSearchResult"];
    },
    resultCount () {
      return this.$store.getters["faq/searchResultCount"];
    },
    searchTerm () {
      return this.$store.getters["faq/searchTerm"];
    },
    articles () {
      return this.$store.getters["faq/searchResults"].articles
    },
    keywords () {
      return this.$store.getters["faq/searchResults"].keywords
    }
  },
  methods: {
    handleFocus() {
      this.focused = true;
    },
    handleBlur() {
      this.focused = false;
    },
    clear() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = null;
    },
    initTimeout() {
      this.clear();
      this.timer = setInterval(async () => {
        await this.runSearch();
      }, 1500);
    },
    async runSearch () {
      this.clear();
      if (this.search === '') return;
      await this.$store.dispatch('faq/search', {search: this.search, lang: this.$store.state.lang.currentLang});
      this.requested = true;
    },
    async handleKeydown(e) {
      const code = e.key || e.code;
      if (code === 'Enter') return this.runSearch();
      this.initTimeout();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/faq/faq-search.vue